export default {
    onClick: actions => {
        actions.resolve();
    },
    enableStoreDetails: false,
    storePaymentMethod: false
};
